module.exports = __webpack_public_path__ + "static/img/ANNEX_EP.99660b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/ANNEX_EP.jpg
// module id = Sndk
// module chunks = 0